import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { Router } from '@angular/router';
import { PopUIEngineComponent } from '../../../pop-uiengine/pop-uiengine.component';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import { DialogModalSize } from '../../../dialog/dialog-ref';
import _moment from 'proxies/dayjs';
import { ChartService } from '../../services/chart.service';

@Component({
    selector: 'app-count',
    templateUrl: './count.component.html',
    standalone: false
})
export class CountComponent implements OnInit {
  @Input() data: any;
  @Input() hideLabels: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  response: any;
  timePeriodList: any;
  moment = _moment;
  filterType = 'fixed';
  constructor(private baseService: BaseService, private loader: LoaderService, private appService: AppService, private router: Router, public dialogService: DialogService, public storage: StorageService, public chartService: ChartService) { }

  ngOnInit() {
    this.chartService.getTimePeriod((timePeriodList)=>{
      this.timePeriodList = timePeriodList;
    })
    if(this.data.widget_id != undefined){
      this.chartService.getWidget(this.data,(res)=>{
        this.data = res.data;
        this.prepareData();
      });
    }
  }
  getData(){
    if(this.filterType == 'fixed'){
      this.prepareData();
    }
  }

  prepareData() {
    this.loader.showSpinner();
    this.data = this.chartService.prepareChartPayload(this.filterType,this.data);
    this.chartService.loadChartData(this.data, (response) => {
      this.response = response;
      this.loader.hideSpinner()
    });
  }

  setFilter(event) {
    console.log('eventis', event)
    // this.data.time_period = event.target.value;
    this.configChanged.emit({ config: { time_period: this.data.time_period } })
    this.prepareData();
  }
  getDrilldown() {
    if (this.data != undefined && this.data.is_drilldown_available != undefined && this.data.is_drilldown_available && this.data.time_period != undefined && this.data.time_period) {
      this.data.filterType = this.filterType;
      this.chartService.getDrilldown(this.data);
    }
  }
  valueChange(e) {
    console.log(e, 'e,q');
    this.data.from = e.FROM;
    this.data.to = e.TO;
    if (this.data.from != null && this.data.to != null){
    this.data.from = this.moment(this.data.from).format("YYYY-MM-DD");
    this.data.to = this.moment(this.data.to).format("YYYY-MM-DD"); 
      this.prepareData();
    }
  }
}
